import { defineMessages } from 'react-intl'

export default defineMessages({
  revised: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderHistory.components.Delivery.revised',
    defaultMessage: 'Revised'
  },
})
